var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeeting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 8,
    fill: "#ECF4FE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 26.3333H20.5M31.3333 19.6667V23M24.6667 19.6667V23M26.75 29.6667L28 28.8333V33M26.9583 33H29.0417M24.5 36.3333H31.5C32.9001 36.3333 33.6002 36.3333 34.135 36.0608C34.6054 35.8212 34.9878 35.4387 35.2275 34.9683C35.5 34.4335 35.5 33.7335 35.5 32.3333V25.3333C35.5 23.9332 35.5 23.2331 35.2275 22.6983C34.9878 22.2279 34.6054 21.8455 34.135 21.6058C33.6002 21.3333 32.9001 21.3333 31.5 21.3333H24.5C23.0999 21.3333 22.3998 21.3333 21.865 21.6058C21.3946 21.8455 21.0122 22.2279 20.7725 22.6983C20.5 23.2331 20.5 23.9332 20.5 25.3333V32.3333C20.5 33.7335 20.5 34.4335 20.7725 34.9683C21.0122 35.4387 21.3946 35.8212 21.865 36.0608C22.3998 36.3333 23.0999 36.3333 24.5 36.3333Z",
    stroke: "#126DD8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeeting);
export default __webpack_public_path__ + "static/media/meeting.7629f9f3f753f8c5c7ab4c6dd0347f37.svg";
export { ForwardRef as ReactComponent };